import withFormikWrapper from '../formik/withFormikWrapper';
import CleanInput from '../cleanInput';

export const CleanFormikInput = withFormikWrapper()(CleanInput);
